import { matchPath, useLocation } from 'react-router';

const OVERVIEW = 'OVERVIEW';
const SEARCH = 'SEARCH';
const TIKTOK = 'TIKTOK';
const INSTAGRAM = 'INSTAGRAM';
const modes = { OVERVIEW, SEARCH, TIKTOK, INSTAGRAM };
const labels = {
    [OVERVIEW]: 'Overview',
    [SEARCH]: 'Google',
    [TIKTOK]: 'TikTok',
    [INSTAGRAM]: 'Instagram',
};

export const tikTokModePaths = [
    '/industries/:industryName/tiktok',
    '/brands/:brandId/tiktok',
    '/category(Two|Three|Four|Five)/:parentId/:categoryId/tiktok',
    '/category(Two|Three|Four|Five)/:categoryId/tiktok',
    '/explore/tiktok/:breakdown(hashtags)/:type(trends|brands)/:categoryId?',
    '/explore/tiktok/:type(trends|brands)/:categoryId?',
    '/explore/related-categories/tiktok/:type(trends)/:categoryId?',
];

const googleModePaths = [
    '/industries/:industryName/google',
    '/brands/:brandId/google',
    '/category(Two|Three|Four|Five)/:parentId/:categoryId/google',
    '/category(Two|Three|Four|Five)/:categoryId/google',
    '/explore/related-categories/google/:type(trends)/:categoryId?',
    '/explore/google/:type(trends|brands)/:categoryId?',
];

const instagramModePaths = [
    '/industries/:industryName/instagram',
    '/brands/:brandId/instagram',
    '/category(Two|Three|Four|Five)/:parentId/:categoryId/instagram',
    '/category(Two|Three|Four|Five)/:categoryId/instagram',
    '/explore/instagram/:breakdown(hashtags)/:type(trends|brands)/:categoryId?',
    '/explore/instagram/:type(trends|brands)/:categoryId?',
    '/explore/related-categories/instagram/:type(trends)/:categoryId?',
];

const getCurrentMode = (pathname) => {
    if (tikTokModePaths.some((path) => matchPath(pathname, { path }))) {
        return modes.TIKTOK;
    }

    if (googleModePaths.some((path) => matchPath(pathname, { path }))) {
        return modes.SEARCH;
    }

    if (instagramModePaths.some((path) => matchPath(pathname, { path }))) {
        return modes.INSTAGRAM;
    }

    return modes.OVERVIEW;
};

const getDataSourceFromMode = (mode) => {
    if (mode === modes.TIKTOK) return 'TIKTOK';
    if (mode === modes.SEARCH) return 'GOOGLE';
    if (mode === modes.INSTAGRAM) return 'INSTAGRAM';
    return 'POPULARITY';
};

const useDataSourceToggle = () => {
    const location = useLocation();
    const mode = getCurrentMode(location.pathname);
    const dataSource = getDataSourceFromMode(mode);
    return { labels, mode, modes, dataSource };
};

export default useDataSourceToggle;
